import { ApiError, apiRequest, authenticatedFetch } from './client'
import { SILKREELS_API_BASE } from './config'
import type {
  SilkCopyright,
  SilkCopyrightList,
  SilkRegisterCopyrightBody,
} from './types'

export const copyrightsApi = {
  list: (params?: { limit?: number; offset?: number }) =>
    apiRequest<SilkCopyrightList>('/api/v1/copyrights', { query: params }),

  get: (id: number) => apiRequest<SilkCopyright>(`/api/v1/copyrights/${id}`),

  /** 公开验真 */
  verify: (publicId: string) =>
    apiRequest<SilkCopyright>(`/api/v1/copyrights/public/${encodeURIComponent(publicId)}`, {
      auth: false,
    }),

  register: (body: SilkRegisterCopyrightBody) =>
    apiRequest<SilkCopyright>('/api/v1/copyrights', { method: 'POST', body }),

  /** 证书 PDF 的 URL,如果直接 <a> 拿不到 Authorization,建议改用 downloadCertificate */
  certificateURL: (id: number) =>
    `${SILKREELS_API_BASE}/api/v1/copyrights/${id}/certificate.pdf`,

  /** 带鉴权头下载 PDF,返回 Blob */
  downloadCertificate: async (id: number): Promise<Blob> => {
    const res = await authenticatedFetch(`/api/v1/copyrights/${id}/certificate.pdf`)
    if (!res.ok) {
      throw new ApiError({
        code: res.status,
        status: res.status,
        message: `download certificate failed: ${res.statusText}`,
      })
    }
    return res.blob()
  },
}
